import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import  NavBar  from './components/NavBar';
import  Banner  from './components/Banner';
import  Services  from './components/Services';
import  Products from './components/Products';
import  Footer from './components/Footer';
import  Clients from './components/clients';
import  Contact from './components/Contact';
import  Filter from './components/Filter';
import  About from './components/About';
import Testimonials from './components/Testimonials';

function App() {
  return (
    <div className="App">
        <NavBar />
        <Banner />
        <Services />
        <Filter />
        <About />
        {/* <Testimonials/> */}
        {/* <Products /> */}
        <Clients/>
        <Contact></Contact>
        <Footer />
    </div>
  );
}

export default App;
